import { useEffect, useState } from 'react';
import { Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';

interface Props {
  id: string;
  value?: number | string | null;
  onChange: (value: number) => void;
  symbol?: string;
  suffix?: string;
  invalid?: boolean;
}

const format = (value?: number | string | null) => {
  const number = Number(value);
  if (value === '' || value === null || value === undefined || isNaN(number)) {
    return '';
  }
  return number.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

/**
 * Input de dinero: con foco se edita el número crudo; al salir se muestra con
 * separador de miles y dos decimales (2,250.00). El valor que sube es numérico.
 */
const MoneyInput = ({
  id,
  value,
  onChange,
  symbol = '$',
  suffix,
  invalid,
}: Props) => {
  const [isFocused, setIsFocused] = useState(false);
  const [text, setText] = useState(format(value));

  // Sincroniza cuando el valor cambia desde afuera y no se está editando.
  useEffect(() => {
    if (!isFocused) setText(format(value));
  }, [value, isFocused]);

  return (
    <InputGroup>
      <InputGroupAddon addonType="prepend">
        <InputGroupText>{symbol}</InputGroupText>
      </InputGroupAddon>
      <Input
        id={id}
        type="text"
        inputMode="decimal"
        autoComplete="off"
        className={`text-dark text-right ${invalid ? 'is-invalid' : ''}`}
        value={text}
        onFocus={(e) => {
          setIsFocused(true);
          // quita comas y el ".00" de relleno para editar cómodo
          setText(Number(value) ? String(Number(value)) : '');
          e.target.select();
        }}
        onChange={(e) => {
          const cleaned = e.target.value
            .replace(/[^0-9.]/g, '')
            .replace(/(\..*)\./g, '$1');
          setText(cleaned);
          onChange(cleaned === '' || cleaned === '.' ? 0 : Number(cleaned));
        }}
        onBlur={() => {
          setIsFocused(false);
          setText(format(value));
        }}
      />
      {suffix && (
        <InputGroupAddon addonType="append">
          <InputGroupText>{suffix}</InputGroupText>
        </InputGroupAddon>
      )}
    </InputGroup>
  );
};

export default MoneyInput;
